import React from 'react'
import MediaUpload from '../MediaUpload'
import MediaGallery from '../MediaGallery'

const MediaSection = ({
  event,
  user,
  showUpload,
  onToggleUpload,
  onUploadSuccess,
  onUploadError,
  onMediaUpdate
}) => {
  const isOwner = event.createdBy?._id?.toString() === user?.id?.toString()

  return (
    <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 p-8">
      <MediaHeader
        isOwner={isOwner}
        showUpload={showUpload}
        onToggleUpload={onToggleUpload}
      />

      {showUpload && isOwner && (
        <UploadSection
          eventId={event._id}
          onUploadSuccess={onUploadSuccess}
          onError={onUploadError}
        />
      )}

      <MediaGallery
        eventId={event._id}
        media={event.media}
        onMediaUpdate={onMediaUpdate}
        onError={onUploadError}
        isOwner={isOwner}
        currentUserId={user?.id}
        eventOwnerId={event.createdBy?._id}
      />
    </div>
  )
}

const MediaHeader = ({ isOwner, showUpload, onToggleUpload }) => (
  <div className="flex items-center justify-between mb-6">
    <h2 className="text-2xl font-bold text-white">📸 Event Media</h2>

    {isOwner && (
      <button
        onClick={onToggleUpload}
        className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold py-2 px-4 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300"
      >
        {showUpload ? '✕ Close Upload' : '📷 Upload Media'}
      </button>
    )}
  </div>
)

const UploadSection = ({ eventId, onUploadSuccess, onError }) => (
  <div className="mb-8 p-6 bg-white/5 rounded-xl border border-white/10">
    <h3 className="text-lg font-semibold text-white mb-4">Upload Photos & Videos</h3>
    <MediaUpload
      eventId={eventId}
      onUploadSuccess={onUploadSuccess}
      onError={onError}
    />
  </div>
)

export default MediaSection